import { AxiosError } from 'axios';

export const isUnAuthorized = (error: AxiosError) =>
  error.response?.status === 401;
